import { type ObjectValuesUnionType } from '../utils/typing';

export const CategoryIds = Object.freeze({
  ESPORT_COUNTER_STRIKE: 800000736,
  ESPORT_SOCCER: 800000750,
  ESPORT_BASKETBALL: 800000751,
  ESPORT_ICE_HOCKEY: 800000752,
  ESPORT_LEAGUE_OF_LEGENDS: 800000737,
  ESPORT_DOTA: 800000738,
  ESPORT_HEARTSTONE: 800000739,
  ESPORT_COD: 800000740,
  ESPORT_OVERWATCH: 800000741,
  ESPORT_STREET_FIGHTER_V: 800000742,
  ESPORT_PUBG: 800000743,
  ESPORT_TEKKEN: 800000744,
  ESPORT_SSBM: 800000745,
  ESPORT_ARTIFACT: 800000746,
  ESPORT_FORTNITE: 800000747,
  ESPORT_MOTOSPORT: 800000748,
  ESPORT_VALORANT: 800000749,
  MMA_UFC: 1089,
  MULTIFOOT: 800000777,
});

export type CategoryId = ObjectValuesUnionType<typeof CategoryIds> | number;
